import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import timeutils from 'utils/wt-time-utils'
// import { getTypeName } from 'enumeration/lab-order.js'
import { getEnumeration } from 'enumeration'
import { doctorLevels } from 'json/doctor-hospital'
import { paymentDrivers } from 'json/index'
import { payOptions } from 'json/new-to-old-audit'
export default {
  createBranchCompany (ctx, data) {
    return fetch.createBranchCompany(data).then(res => {
      return res.data
    })
  },
  updateBranchCompany (ctx, data) {
    return fetch.updateBranchCompany(data).then(res => {
      return res.data
    })
  },
  getBranchCompanyDetail (ctx, data) {
    return fetch.getBranchCompanyDetail(data).then(res => {
      let result = res.data
      return result
    })
  },
  getBranchCompanyList (ctx, data) {
    return fetch.getBranchCompanyList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  deleteBranchCompany (ctx, data) {
    return fetch.deleteBranchCompany(data).then(res => {
      return res.data
    })
  },
  createHospital (ctx, data) {
    return fetch.createHospital(data).then(res => {
      return res.data
    })
  },
  updateHospital (ctx, data) {
    return fetch.updateHospital(data).then(res => {
      return res.data
    })
  },
  getHospitalDetail (ctx, data) {
    return fetch.getHospitalDetail(data).then(res => {
      let result = res.data
      return result
    })
  },
  getHospitalList (ctx, data) {
    return fetch.getHospitalList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getUserByMobile (ctx, data) {
    return fetch.getUserByMobile(data).then(res => {
      return res
    })
  },
  getUserByLogin (ctx, login) {
    return fetch.getUserByLogin(login).then(res => {
      return res
    })
  },
  deleteHospital (ctx, data) {
    return fetch.deleteHospital(data).then(res => {
      return res.data
    })
  },
  createDoctor (ctx, data) {
    return fetch.createDoctor(data).then(res => {
      return res.data
    })
  },
  importDoctorList (ctx, data) {
    return fetch.importDoctorList(data).then(res => {
      return res.data
    })
  },
  updateDoctor (ctx, data) {
    return fetch.updateDoctor(data).then(res => {
      return res.data
    })
  },
  getDoctorDetail (ctx, data) {
    return fetch.getDoctorDetail(data).then(res => {
      let result = res.data
      result.joinObstetricsQA = result.joinObstetricsQA + ''
      result.created_date = result.createDate && timeutils.format(result.createDate)
      result.qaHospitalIds = result.qaHospitalIds && result.qaHospitalIds[0]
      result.position = result.positionCode && getEnumeration(result.positionCode, doctorLevels)
      return result
    })
  },
  getDoctorList (ctx, data) {
    return fetch.getDoctorList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(element => {
        let addressDetails = element.addressDetails || {}
        element.provinceName = addressDetails.provinceName || '--'
        element.cityName = addressDetails.cityName || '--'
        element.create_date = element.createDate && timeutils.format(element.createDate, 'YYYY-MM-DD')
        if (element.hospital) {
          element.hospitalNum = element.hospital.length
        }
        element.idCard = element.idCard || '--'
        element.branchCompanyName = element.branchCompanyName || '--'
      })
      return result
    })
  },
  deleteDoctor (ctx, data) {
    return fetch.deleteDoctor(data).then(res => {
      return res.data
    })
  },
  getBrachBusinessType (ctx, data) {
    return fetch.getBrachBusinessType(data).then(res => {
      return res.data
    })
  },
  exportDoctorQrcode (ctx, data) {
    return fetch.exportDoctorQrcode(data).then(res => {
      return res
    })
  },
  exportDoctorList (ctx, data) {
    return fetch.exportDoctorList(data).then(res => {
      return res
    })
  },
  getOrganizationMerchant (ctx, data) {
    return fetch.getOrganizationMerchant(data).then(res => {
      let result = res.data
      result.forEach(item => {
        item.channel_show = item.channel && getEnumeration(item.channel, payOptions)
        item.driver = item.properties && item.properties.driver && paymentDrivers[item.properties.driver]
        item.forEndUser = item.properties && (item.properties.forEndUser === false || item.properties.forEndUser === 'false') ? '否' : '是'
        item.config = item.config ? JSON.stringify(item.config) : ''
      })
      return result
    })
  }
}
